import type { IconProps } from "@/types/icon";

const Edit = ({ color = "#4D0FFF", className }: IconProps) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.79753 11.8223C1.82624 11.5639 1.8406 11.4347 1.8797 11.3139C1.91438 11.2068 1.9634 11.1048 2.0254 11.0108C2.09528 10.9048 2.18722 10.8129 2.37108 10.629L10.625 2.37507C11.3154 1.68471 12.4347 1.68471 13.125 2.37507C13.8154 3.06542 13.8154 4.18471 13.125 4.87507L4.87108 13.129C4.68722 13.3129 4.59528 13.4048 4.4893 13.4747C4.39528 13.5367 4.29331 13.5857 4.18615 13.6204C4.06538 13.6595 3.93616 13.6738 3.67773 13.7025L1.5625 13.9376L1.79753 11.8223Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Edit;
